<template>
  <div class="km-products-page">
    <!-- 页面横幅 -->
    <div class="page-banner">
      <div class="page-banner-inner">
        <div class="page-banner-tag">Products</div>
        <h1 class="page-banner-title">产品中心</h1>
        <p class="page-banner-desc">专业的电容器自动化设备解决方案</p>
      </div>
    </div>

    <!-- 产品内容 -->
    <div class="products-content k-container">
      <prod-box></prod-box>
    </div>
  </div>
</template>

<script>
import ProdBox from './prod-box.vue';

export default {
  name: 'index',
  data() {
    return {};
  },
  components: {
    ProdBox,
  },
};
</script>

<style scoped lang="less">
.km-products-page {
  min-height: 100vh;
  background: var(--bg-secondary);
}

/* 页面横幅 */
.page-banner {
  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary) 100%);
  padding: 48px 24px;
  text-align: center;
}

.page-banner-inner {
  max-width: 800px;
  margin: 0 auto;
}

.page-banner-tag {
  display: inline-block;
  padding: 4px 14px;
  background: rgba(255, 140, 0, 0.25);
  color: #ff8c00;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.page-banner-title {
  font-size: 40px;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 12px;
}

.page-banner-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

/* 产品内容区 */
.products-content {
  padding-top: 40px;
  padding-bottom: 60px;
}

/* 响应式 */
@media (max-width: 768px) {
  .page-banner {
    padding: 36px 16px;
  }

  .page-banner-title {
    font-size: 30px;
  }

  .page-banner-desc {
    font-size: 14px;
  }

  .products-content {
    padding-top: 28px;
    padding-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .page-banner {
    padding: 28px 12px;
  }

  .page-banner-title {
    font-size: 24px;
  }
}
</style>
